<template>
  <div class="release-edit app-form-styling flex column gap20" :class="{'design-mode': showDesign}" v-if="itemToEdit && org">
    <!-- <header class="header tab-nav">
      <div class="container width-all">
        <button @click="showDesign = false" :class="{selected: !showDesign}">{{$t('releaseLocales.editRelease')}}</button>
        <button :disabled="!itemToEdit._id" @click="showDesign = true" :class="{selected: showDesign}">{{$t('releaseLocales.designAndPreview')}}</button>
      </div>
    </header> -->
    <main class="form-content container flex column gap30 width-all">
      <template v-if="!showDesign">
        <h2>{{$t(itemToEdit._id? 'releaseLocales.editRelease' : 'releaseLocales.createRelease')}} > {{selectedReleaseTypeItem?.name || ''}}</h2>
        <form v-if="itemToEdit" @submit.prevent="" class="flex column gap20">
          <FormInput class="static-input gap30 align-start locale-select" type="select" labelholder="locale" :itemsMap="{'English': 'en', 'עברית': 'he', 'Français': 'fr'}" v-model="itemToEdit.design.locale"/>
          <FormInput class="static-input gap30 align-start expiration-date" type="date" labelholder="releaseLocales.expirationDate" v-model="itemToEdit.expirationDate" format_="timeMS"/>
          <DynamicInput v-for="(dataField, idx) in dataFields" :key="idx" :dataField="dataField" :basePath="dataField.fieldName" :value="getVal(dataField.fieldName)" @input="(val, setPath, isForceUpdate) => setVal(val, setPath, isForceUpdate)" :release="itemToEdit" :parentItem="itemToEdit.releaseData" :organization="org"/>
          
          <!-- NEW: Permissions & 2FA Configuration Section -->
          <ReleasePermissionsConfig 
            v-if="org && (org.features?.itemLevelPermissions || org.features?.encryptedVideosSection || org.features?.releaseLevel2FA)"
            :release="itemToEdit" 
            :organization="org"
            @update="handlePermissionsUpdate"
          />
        </form>
      </template>
      <ReleaseDesignViewer
        @close="showDesign = false"
        v-else
        :release="itemToEdit"
        :organization="org"
        @design-template-updated="handleDesignChange"
        :randUrlId="randIframeUrlId"
      />
    </main>
    <footer class="footer width-all">
      <div class="flex gap40 align-center space-between container height-all">
        <div class="wide-screen-item">
          <button class="underline btn__ big" v-if="itemToEdit._id" @click="deleteItem">{{$t('delete')}}</button>
        </div>
        <div class="flex align-center gap30 height-all wrap">
          <button class="btn big" @click="close">{{$t('close')}}</button>
          <button class="btn big" v-if="showDesign" @click="showDesign = false">{{$t('releaseLocales.editRelease')}}</button>
          <button class="btn big ignor-flex flex align-center gap15" v-if="!showDesign" :disabled="!itemToEdit._id" @click="showDesign = true" ><div v-html="svgs.PreviewActions.eye" class="svg-parrent"></div><span>{{$t('releaseLocales.designAndPreview')}}</span></button>
          <button class="btn big ignor-flex flex align-center gap15" :disabled="!isItemValid" @click="saveItem"><div v-html="svgs.save" class="svg-parrent"></div><span>{{$t('save')}}</span></button>
          <button class="btn big primary ignor-flex flex align-center gap15" :disabled="!isItemValid" @click="confirmAndDistribute"><div v-html="svgs.PreviewActions.distribute" class="svg-parrent"></div><span>{{$t('distributeLocales.distribute')}}</span></button>
          <button class="underline btn__ big small-screen-item" v-if="itemToEdit._id" @click="deleteItem">{{$t('delete')}}</button>
          <!-- <template v-if="isScreenWide">
          </template>
          <button v-else class="btn big primary" :disabled="!isItemValid" @click="saveItemAndClose">
            {{$t('save')}}
          </button> -->
          <!-- <button v-if="isScreenWide" class="btn big primary  bg-4 clr-1" :disabled="!isItemValid" @click="confirmAndDistribute">{{$t('releaseLocales.confirmAndDistribute')}}</button>
          <button v-else class="btn big primary  bg-4 clr-1" :disabled="!isItemValid" @click="confirmAndDistribute">{{$t('distributeLocales.distribute')}}</button> -->
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { Utils } from '../../../../common/modules/common/services/util.service';
import DynamicInput from '../cmps/DynamicFormInputs/DynamicInput.vue';
import { createItemForDynamicForm } from '../../common/services/dynamicFormService';
import { alertService } from '@/apps/common/modules/common/services/alert.service';
import ReleaseDesignViewer from '../cmps/ReleaseDesignViewer.vue';
import { templateUtils } from '../../../../common/modules/common/services/template.util.service';
import FormInput from '../../../../common/modules/common/cmps/FormInput.vue';
import evManager from '@/apps/common/modules/common/services/event-emmiter.service.js';
import { elementService } from '../../../../common/modules/common/services/element.service';
import { getSvgs } from '../../../assets/images/svgs';
export default {
  name: 'ReleaseEdit',
  data() {
    return {
      itemToEdit: null,
      initialItem: null,
      org: null,
      showDesign: false,

      dataFields: [],
      randIframeUrlId: Utils.getRandomId('')
    }
  },
  computed: {
    orgId() {
      return this.$route.params.organizationId;
    },
    isItemValid() {
      return !!this.itemToEdit;
    },
    queryReleaseType() {
      return this.$route.query.releaseType;
    },
    releaseType() {
      return this.itemToEdit?.releaseType || this.queryReleaseType || '';
    },

    selectedReleaseTypeItem() {
      if (!this.org || !this.releaseType) return null;
      // return this.org.releaseTypes.find(c => c.id === this.releaseType);
      return templateUtils.getRelevantReleaseTypeItemForRelease(this.releaseType, this.org);
    },
    // dataFields() {
    //   if (!this.selectedReleaseTypeItem) return []
    //   const dataFields = JSON.parse(this.selectedReleaseTypeItem.dataFieldsStr);
    //   return dataFields;
    // },

    didChange() {
      return JSON.stringify(this.itemToEdit) !== JSON.stringify(this.initialItem);
    },

    isScreenWide() {
      return this.$store.getters.isScreenWide;
    },

    
    svgs() {
      return getSvgs();
    }
  },
  methods: {
    async loadReleaseDataFields() {
      const allFields = await this.$store.dispatch({ type: 'organization/loadReleaseDataFields', dataFieldsLocalFilePath: this.selectedReleaseTypeItem?.dataFieldsLocalFilePath, organizationId: this.orgId, releaseType: this.releaseType });
      
      // Filter out disabled fields
      let filteredFields = allFields.filter(c => !c.disabled);
      
      // FILTER/ADD BASED ON FEATURE FLAGS:
      // Check if encryptedVideosSection feature is enabled
      const isEncryptedVideosEnabled = this.org && this.org.features?.encryptedVideosSection === true;
      
      if (isEncryptedVideosEnabled) {
        // Feature is enabled - ensure field exists
        const hasEncryptedVideosField = filteredFields.some(field => field.fieldName === 'encryptedVideos');
        if (!hasEncryptedVideosField) {
          // Find the position to insert - after the "videos" field (which is in the "watch" section)
          const videosFieldIndex = filteredFields.findIndex(field => field.fieldName === 'videos');
          const insertIndex = videosFieldIndex >= 0 ? videosFieldIndex + 1 : filteredFields.length;
          
          // Create separator and field
          const separatorField = {
            title: 'וידאו מוצפן',
            fieldName: '',
            type: 'SEPARATOR',
            helpText: 'העלאת קבצי וידאו מוצפנים (HLS עם DRM)',
            isSearchable: false
          };
          
          const encryptedVideosField = {
            title: '',
            fieldName: 'encryptedVideos',
            type: 'TABLE',
            helpText: '',
            uiTitle: 'וידאו מוצפן',
            uiType: 'encryptedVideos',
            uiSections: ['watch'],
            index: 100, // Add index to ensure proper ordering
            fields: [
              {
                title: 'סוג',
                type: 'SELECT',
                fieldName: 'videoType',
                options: [
                  { label: 'פרק/סרט מלא', value: 1 },
                  { label: 'פרומו', value: 2 },
                  { label: 'טיזר', value: 3 },
                  { label: 'טריילר', value: 4 }
                ]
              },
              {
                title: 'כותרת',
                type: 'TEXT',
                fieldName: 'title'
              },
              {
                title: 'קובץ וידאו',
                type: 'FILE',
                fieldName: 'fileId',
                props: {
                  accept: 'video/*'
                }
              }
            ]
          };
          
          // Insert separator and field after the videos field
          filteredFields.splice(insertIndex, 0, separatorField, encryptedVideosField);
        }
        // If field already exists in template, keep it
      } else {
        // Feature is NOT enabled - hide encryptedVideos field
        filteredFields = filteredFields.filter(field => field.fieldName !== 'encryptedVideos');
      }

      // Non-legacy (schema) editing mode: hide `showInLargeDesign` toggle for textItems sections.
      // Mode marker in data: `organization.templateMode === 'schema'`.
      const isSchemaMode = this.org?.templateMode === 'schema'
      if (isSchemaMode) {
        filteredFields = filteredFields.map((field) => {
          if (field?.fieldName !== 'sections' || field?.type !== 'LIST' || !Array.isArray(field?.fieldOpts)) return field
          const nextFieldOpts = field.fieldOpts.map((opt) => {
            if (!Array.isArray(opt)) return opt
            const typeDef = opt.find((f) => f?.type === 'TYPE')
            if (typeDef?.defaultValue !== 'textItems') return opt
            const withoutLargeDesign = opt.filter((f) => f?.fieldName !== 'largeDesign')
            const hasSubitemsLook = withoutLargeDesign.some((f) => f?.fieldName === 'subitemsLook')
            const hasSingleLook = withoutLargeDesign.some((f) => f?.fieldName === 'singleLook')
            const hasSingleLookImageLeft = withoutLargeDesign.some((f) => f?.fieldName === 'singleLookImageLeft')
            if (hasSubitemsLook && hasSingleLook && hasSingleLookImageLeft) return withoutLargeDesign
            const subitemsLookField = {
              type: 'CHECKBOX',
              title: 'subitemsLook',
              fieldName: 'subitemsLook'
            }
            const singleLookField = {
              type: 'CHECKBOX',
              title: 'singleLook',
              fieldName: 'singleLook'
            }
            const singleLookImageLeftField = {
              type: 'CHECKBOX',
              title: 'singleLookImageLeft',
              fieldName: 'singleLookImageLeft'
            }
            const moreInfoIdx = withoutLargeDesign.findIndex((f) => f?.fieldName === 'moreInfo')
            if (moreInfoIdx === -1) {
              return [
                ...withoutLargeDesign,
                ...(hasSubitemsLook ? [] : [subitemsLookField]),
                ...(hasSingleLook ? [] : [singleLookField]),
                ...(hasSingleLookImageLeft ? [] : [singleLookImageLeftField])
              ]
            }
            const next = [...withoutLargeDesign]
            const inserts = []
            if (!hasSubitemsLook) inserts.push(subitemsLookField)
            if (!hasSingleLook) inserts.push(singleLookField)
            if (!hasSingleLookImageLeft) inserts.push(singleLookImageLeftField)
            next.splice(moreInfoIdx + 1, 0, ...inserts)
            return next
          })
          return { ...field, fieldOpts: nextFieldOpts }
        })
      }
      
      this.dataFields = filteredFields;
    },
    async getOrg() {
      this.org = await this.$store.dispatch({ type: 'organization/loadItem', id: this.orgId, isToInheritData: true });
    },
    async getItem() {
      this.dataFields = [];
      this.itemToEdit = null;
      // Ensure org is loaded before loading data fields (needed for feature flag checks)
      if (!this.org) {
        await this.getOrg();
      }
      this.itemToEdit = await this.$store.dispatch({ type: 'release/loadItem', id: this.$route.params.id, organizationId: this.orgId });
      const isNew = !this.itemToEdit._id
      if (!this.itemToEdit._id) {
        const loc = this.$store.getters['settings/uiConfig']?.locale || this.$store.getters.envManagement?.defaultLocale;
        if (loc) this.itemToEdit.design.locale = loc;
      }
      await this.loadReleaseDataFields();
      if (!this.itemToEdit.organizationId) this.itemToEdit.organizationId = this.orgId;
      if (!this.itemToEdit.releaseType) this.itemToEdit.releaseType = this.releaseType;
      const emptyDataItem = createItemForDynamicForm(this.dataFields);
      for (let key in emptyDataItem) {
        if (this.itemToEdit.releaseData[key] === undefined) this.itemToEdit.releaseData[key] = emptyDataItem[key];
      }

      // If release was created from the schema wizard, prefill 1 section instance per enabled section type.
      // This matches the expectation that selecting both `images` and `links` shows both in the new release editor.
      if (isNew) {
        const sectionsField = this.dataFields.find(f => f?.fieldName === 'sections' && f?.type === 'LIST')
        const currentSections = this.itemToEdit.releaseData?.sections
        const hasSections = Array.isArray(currentSections) && currentSections.length > 0
        if (!hasSections && Array.isArray(sectionsField?.fieldOpts) && sectionsField.fieldOpts.length) {
          const initialSections = sectionsField.fieldOpts.map(optFields => createItemForDynamicForm(optFields))

          // Optional: apply tabsOrder ordering (if schema template exists for this org+releaseType).
          const tabsOrder = this.org?.schemaTemplates?.[this.releaseType]?.tabsOrder
          if (Array.isArray(tabsOrder) && tabsOrder.length) {
            const idxMap = new Map(tabsOrder.map((t, idx) => [t, idx]))
            initialSections.sort((a, b) => (idxMap.has(a?._listItemType) ? idxMap.get(a._listItemType) : 999) - (idxMap.has(b?._listItemType) ? idxMap.get(b._listItemType) : 999))
          }

          this.itemToEdit.releaseData.sections = initialSections
        }
      }

      // Remove require2FA from releaseData if it exists there (it should be top-level)
      if (this.itemToEdit.releaseData.require2FA !== undefined) {
        if (this.itemToEdit.require2FA === undefined) {
          this.itemToEdit.require2FA = this.itemToEdit.releaseData.require2FA;
        }
        delete this.itemToEdit.releaseData.require2FA;
      }
      this.initialItem = JSON.parse(JSON.stringify(this.itemToEdit));
    },
    async saveItem() {
      if (!this.isItemValid) return;
      const isNew = !this.itemToEdit._id;
      const previousEncryptedVideos = JSON.parse(JSON.stringify(this.itemToEdit.releaseData?.encryptedVideos || []));
      const savedItem = await this.$store.dispatch({ type: 'release/saveItem', item: this.itemToEdit, organizationId: this.orgId });
      const savedId = savedItem?._id || this.itemToEdit._id;

      if (isNew && savedId) {
        await this.$router.push({ params: { id: savedId } });
        return;
      }

      let nextItem = await this.hydrateSavedRelease(savedId, previousEncryptedVideos);
      if (!nextItem) {
        nextItem = this.buildSavedItemFallback(savedItem, previousEncryptedVideos);
      }
      if (nextItem) {
        nextItem.__newFiles__ = [];
        this.itemToEdit = nextItem;
        this.initialItem = JSON.parse(JSON.stringify(this.itemToEdit));
      }
    },
    async saveItemAndClose() {
      await this.saveItem();
      this.close();
    },
    async confirmAndDistribute() {
      await this.saveItem();
      this.$router.push({ name: 'ReleaseDistribution', params: { organizationId: this.orgId, id: this.$route.params.id } });
    },


    async deleteItem() {
      await this.$store.dispatch({ type: 'release/removeItem', id: this.$route.params.id, organizationId: this.orgId });
      this.navigateOut();
    },
    async close() {
      // if (
      //   this.didChange && 
      //   !await alertService.Confirm(this.$t('releaseLocales.alerts.leaveConfirm'))
      // ) return;
      this.navigateOut();
    },
    navigateOut() {
      const orgId = this.orgId || this.org?._id || this.itemToEdit?.organizationId || this.$route.params.organizationId;
      if (!orgId) {
        console.error('Cannot navigate: organizationId is missing', {
          routeParams: this.$route.params,
          org: this.org,
          itemToEdit: this.itemToEdit
        });
        return;
      }
      this.$router.push({ name: 'ReleasePage', params: { organizationId: orgId } });
    },

    getVal(fieldPath) {
      if (!fieldPath) return undefined;
      // Top-level release fields (not in releaseData)
      const topLevelFields = ['require2FA', 'expirationDate'];
      if (topLevelFields.includes(fieldPath)) {
        return this.itemToEdit[fieldPath];
      }
      return Utils.getDeepVal(this.itemToEdit.releaseData, fieldPath);
    },
    setVal(val, fieldPath) {
      // Top-level release fields (not in releaseData)
      const topLevelFields = ['require2FA', 'expirationDate'];
      if (topLevelFields.includes(fieldPath)) {
        this.$set(this.itemToEdit, fieldPath, val);
        this.$forceUpdate();
        return;
      }
      Utils.setDeepVal(this.itemToEdit.releaseData, fieldPath, val);

      // landing2 textItems mode toggles must be mutually exclusive
      if (/^sections\.\d+\.(singleLook|subitemsLook)$/.test(fieldPath) && !!val) {
        const sectionPath = fieldPath.replace(/\.(singleLook|subitemsLook)$/, '')
        const changedFieldName = fieldPath.endsWith('.singleLook') ? 'singleLook' : 'subitemsLook'
        const oppositeFieldName = changedFieldName === 'singleLook' ? 'subitemsLook' : 'singleLook'
        Utils.setDeepVal(this.itemToEdit.releaseData, `${sectionPath}.${oppositeFieldName}`, false)
      }

      // schema-only textItems "single look":
      // when enabling and no explicit row selected yet, default to first sub-item.
      if (/^sections\.\d+\.singleLook$/.test(fieldPath) && !!val) {
        const sectionPath = fieldPath.replace(/\.singleLook$/, '')
        const itemsPath = `${sectionPath}.textItems`
        const items = Utils.getDeepVal(this.itemToEdit.releaseData, itemsPath)
        if (Array.isArray(items) && items.length) {
          const hasSelected = items.some((item) => !!item?.singleLookSelected)
          if (!hasSelected) {
            const nextItems = items.map((item, idx) => ({ ...(item || {}), singleLookSelected: idx === 0 }))
            Utils.setDeepVal(this.itemToEdit.releaseData, itemsPath, nextItems)
          }
        }
      }

      this.itemToEdit.releaseData = {...this.itemToEdit.releaseData};
      this.$forceUpdate();
    },


    onFileUploaded(file) {
      // delete file.src;
      // if (this.itemToEdit._id) return;
      if (!this.itemToEdit.__newFiles__) this.itemToEdit.__newFiles__ = [];
      this.itemToEdit.__newFiles__.push(file);
    },

    async handleDesignChange(key, val) {
      this.itemToEdit.design[key] = val;
      await this.saveItem();
      this.randIframeUrlId = Utils.getRandomId('');
    },

    handleBeforeUnload(event) {
      if (this.didChange) {
        // Trigger browser's native confirmation dialog
        event.preventDefault();
        event.returnValue = ''; // Modern browsers require this
        return ''; // For older browsers
      }
    },
    
    handlePermissionsUpdate(updatedData) {
      // Merge permissions and 2FA config into itemToEdit
      if (updatedData.permissions) {
        this.$set(this.itemToEdit, 'permissions', updatedData.permissions);
      }
      if (updatedData.require2FAConfig) {
        this.$set(this.itemToEdit, 'require2FAConfig', updatedData.require2FAConfig);
      }
      this.$forceUpdate();
    },
    buildSavedItemFallback(savedItem, previousEncryptedVideos) {
      if (!savedItem) return this.itemToEdit;
      const fallbackReleaseData = savedItem.releaseData !== undefined
        ? savedItem.releaseData || {}
        : (this.itemToEdit.releaseData || {});
      const mergedReleaseData = {
        ...(fallbackReleaseData || {})
      };
      if (fallbackReleaseData.encryptedVideos === undefined && previousEncryptedVideos?.length) {
        mergedReleaseData.encryptedVideos = previousEncryptedVideos;
      }
      return {
        ...this.itemToEdit,
        ...savedItem,
        releaseData: mergedReleaseData
      };
    },
    async hydrateSavedRelease(releaseId, previousEncryptedVideos = []) {
      if (!releaseId) return null;
      try {
        const service = this.$store.getters['release/service'];
        if (!service?.get) return null;
        const freshRelease = await service.get(releaseId, this.orgId);
        if (!freshRelease) return null;
        const mergedReleaseData = {
          ...(freshRelease.releaseData || {})
        };
        if (mergedReleaseData.encryptedVideos !== undefined) {
          mergedReleaseData.encryptedVideos = this.mergeEncryptedVideosState(previousEncryptedVideos, mergedReleaseData.encryptedVideos);
        }
        return {
          ...this.itemToEdit,
          ...freshRelease,
          releaseData: mergedReleaseData
        };
      } catch (err) {
        console.error('Failed to hydrate release after save', err);
        return null;
      }
    },
    mergeEncryptedVideosState(previousList = [], serverList = []) {
      if (!Array.isArray(serverList)) return previousList || [];
      if (!Array.isArray(previousList) || !previousList.length) return serverList;
      const previousMap = new Map();
      previousList.forEach(video => {
        const id = this.getVideoIdentity(video);
        if (id) previousMap.set(id, video);
      });
      return serverList.map(video => {
        const id = this.getVideoIdentity(video);
        if (!id || !previousMap.has(id)) return video;
        const previous = previousMap.get(id);
        return {
          ...video,
          status: previous.status ?? video.status,
          encryptionProgress: previous.encryptionProgress ?? video.encryptionProgress
        };
      });
    },
    getVideoIdentity(video = {}) {
      if (!video) return null;
      const fileId = video.fileId;
      if (typeof fileId === 'string') return fileId;
      if (fileId && typeof fileId === 'object') {
        return fileId.fileId || fileId._id || fileId.id || null;
      }
      return video._id || null;
    }
  },
  mounted() {
    setTimeout(() => {
      window.scroll(0, 0);
    }, 300);
    // Add beforeunload listener to warn about unsaved changes
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  async created() {
    await this.getOrg();
    // await this.loadReleaseDataFields();
    await this.getItem();
    evManager.on('file-uploaded', this.onFileUploaded);
  },
  destroyed() {
    evManager.off('file-uploaded', this.onFileUploaded);
    // Remove beforeunload listener
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  watch: {
    '$route.params.id'() {
      this.getItem();
    },
    queryReleaseType() {
      this.getItem();
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (!this.didChange) return next();
    const doesWantToLeave = await alertService.Confirm(this.$t('releaseLocales.alerts.leaveConfirm'), undefined, '<style>.A-Alert .alert-modal .a-alert-confirm-btn {border: none !important; box-shadow: none !important;}</style>');
    if (!doesWantToLeave) return next(false);
    else return next(true);
  },
  components: {
    DynamicInput,
    ReleaseDesignViewer,
    FormInput,
    ReleasePermissionsConfig: () => import('../cmps/ReleasePermissionsConfig.vue'),
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/global/index';
.megaphon-app {
  .release-edit {
    .svg-parrent, svg {
      width: auto;
      // height: 0.8em;
    }
    padding-top: rem(20px);
    &.design-mode {
      overflow: hidden;
      max-height: 100vh;
    }
    .form-content {
      padding: em(10px);
    }
    .dynamic-input:not(.input-field-SEPARATOR) h3, .static-input .label {
      width: em(150px);
      font-size: em(16px);
      font-weight: normal;
    }
    .input-field-LIST .LIST h3 {
      width: em(75px);
    }

    .form-input {
      &-text, &-select, &-date {
        height: em(40px);
        input {
          border-radius: 0;
        }
      }
      &-textarea {
        height: em(300px);
      }
    }

    .static-input {
      gap: em(30px) !important;
      p {
        width: em(100px);
        color: var(--clr-0-d-20);
      }
    }

    // h2, h3 {
    //   color: #0084D4;
    // }
    h3 {
      color: var(--clr-0-d-20);
    }
    footer {
      padding: em(10px);
      position: fixed; 
      width: 100%;
      bottom: 0;
      inset-inline-end: 0;
      min-height: em(50px);
      background-color: #E0E0E0;
      padding: em(10px);

      @media (min-width: $small-screen-break) {
        top: 0;
        inset-inline-end: 0;
        z-index: 100;
        // width: 50%;
        width: unset;
        background-color: unset;
        height: $header-height;
      }
    }
    main {
      margin-bottom: em(50px);
      padding: em(20px) 0;
    }
  }
}

</style>